import React, { useEffect } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Block from "@material-ui/icons/Block";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#0091ff",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  completed: {
    color: "#c23934",
    zIndex: 1,
    fontSize: 22,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;
  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Block className={classes.completed} />
      ) : (
        <RadioButtonCheckedIcon />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};
function getSteps() {
  return [
    "Transportation Ordered",
    "Transportation Scheduled",
    "Transportation Enroute",
    "Vehicle Picked Up",
  ];
}
let transportMetaData = [
  "Transportation Ordered",
  "Transportation Scheduled",
  "Transportation Enroute",
  "Vehicle Picked Up",
];
export default function VerticalVehicleStepper(props) {
  const classes = useStyles();
  const [completed, setCompleted] = React.useState([false,false,false,false]);

  const steps = getSteps();

  const transportDetails = props.transportData;

  useEffect(() => {
    setTransportInformation();
    console.log("startpassed verticle stepped", new Date());
    return () =>{
      setCompleted([false,false,false,false]);
    }
  
  }, [props.transportData,props.vin]);


  const handleComplete = (completedSteps) => {
    let completedsteps = [false,false,false,false];
    
    for (let i = 0; i <= completedSteps; i++) {
      completedsteps[i]=true;
    }
    setCompleted(completedsteps);
  };

  const setTransportInformation = () => {
     transportDetails?.data?.length > 0 &&
      transportDetails?.data?.map((row) => {
        if (row.vin === props.vin) {    
           transportMetaData.map((trp, index) => {
            if (trp === row.derivedStatus) {
               handleComplete(index);
            }
            return trp
          });
        }
       return row
      });
  };
  return (
    <div className={classes.root}>
      {/* {console.log("COMPLETED=",completed)} */}
      <Stepper nonLinear orientation="vertical">
        {steps.map((label, index) => {
          return (
            <Step key={label} active={completed[index]}>
              <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
